import { Lock, Sparkles } from "lucide-react";
import { useCanAccess } from "@/lib/plan";

/**
 * ProGate — wraps a Pro-only feature area.
 * Pro users see `children`; free users see a locked upgrade card.
 *
 *   <ProGate feature="checklists" title="Checklists"
 *            description="Winterizing, spring commissioning...">
 *       <ChecklistsView ... />
 *   </ProGate>
 */
export default function ProGate({ feature, title, description, children }) {
    const { isPro, upgrade } = useCanAccess();
    if (isPro) return children;

    return (
        <div
            data-testid={`pro-gate-${feature}`}
            className="bm-card"
            style={{
                padding: "44px 32px",
                textAlign: "center",
                maxWidth: 560,
                margin: "24px auto",
                border: "1px solid var(--bm-gold-dim, rgba(212,181,114,0.3))",
            }}
        >
            <div style={{
                width: 52, height: 52, borderRadius: 14, margin: "0 auto 18px",
                background: "linear-gradient(135deg, rgba(212,181,114,0.18), rgba(212,181,114,0.05))",
                border: "1px solid var(--bm-gold-dim, rgba(212,181,114,0.3))",
                display: "flex", alignItems: "center", justifyContent: "center",
            }}>
                <Lock size={22} color="var(--bm-gold)" />
            </div>
            <div style={{ fontSize: 11, letterSpacing: "0.24em", textTransform: "uppercase", color: "var(--bm-gold)", marginBottom: 8 }}>
                Bosun's Mate Pro
            </div>
            <h3 className="bm-serif" style={{ fontSize: 24, margin: "0 0 10px", fontWeight: 500, color: "var(--bm-text)" }}>
                {title}
            </h3>
            <p style={{ color: "var(--bm-text-muted)", fontSize: 14, lineHeight: 1.6, margin: "0 auto 22px", maxWidth: 420 }}>
                {description}
            </p>
            <button
                data-testid={`pro-gate-upgrade-btn-${feature}`}
                onClick={upgrade}
                className="bm-btn bm-btn-gold"
                style={{ padding: "11px 24px", fontSize: 14, display: "inline-flex", alignItems: "center", gap: 8 }}
            >
                <Sparkles size={15} /> Upgrade to Pro — from $4.99/mo
            </button>
        </div>
    );
}

/** Small inline lock pill for buttons/rows that lead to Pro features. */
export function ProPill() {
    return (
        <span
            data-testid="pro-pill"
            style={{
                display: "inline-flex", alignItems: "center", gap: 4,
                fontSize: 10, fontWeight: 700, letterSpacing: "0.08em",
                color: "var(--bm-gold)", border: "1px solid var(--bm-gold-dim, rgba(212,181,114,0.35))",
                borderRadius: 999, padding: "2px 8px", textTransform: "uppercase",
            }}
        >
            <Lock size={9} /> Pro
        </span>
    );
}
